import * as React from 'react';
import Section from '../ui/Section';
import { IInstanceForm, IFormValidationProperties, IFormValidation, IFormValidationEvent } from '../../model/forms';
import { IFieldEvent } from '../fields/interfaces';

interface IInstancedSectionsDefaultableProperties {  
  maxNumberOfSections: number;
}

export interface IInstanceFunctions<T extends IInstanceForm> extends IFormValidationProperties{
  isEmpty?: (instance: T) => boolean;
  onFieldChange?: (event: IFieldEvent) => void;
}

export interface IInstancedSectionsProperties<TInstance extends IInstanceForm> extends IInstancedSectionsDefaultableProperties, IFormValidationProperties{
  label: string;
  noSectionText: string;
  instances: Map<number, TInstance>;
  validation?: IFormValidation;
  onFieldChange?: (event: IInstancedSectionFieldEvent) => void;
  onAddInstance?: () => void;
  onRemoveInstance?: (instanceId: number) => void;
  isEmpty?: (instance: TInstance) => boolean;
}

export interface IInstancedSectionFieldEvent extends IFieldEvent {
  instanceId: number;
}

export abstract class InstancedSectionBase<TInstance extends IInstanceForm> extends React.PureComponent<IInstancedSectionsProperties<TInstance>> {
  //default property values
  public static defaultProps: IInstancedSectionsDefaultableProperties = {
    maxNumberOfSections: 10
  }

  constructor(props: IInstancedSectionsProperties<TInstance>) {
    super(props);

    this.addInstanceAvailable = this.addInstanceAvailable.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
  }

  public abstract getComponents() : React.ReactElement[]; //must be implemented in derived class.

  public addInstanceAvailable() {
    if (this.props.instances.size === 0)
    {
      return true;
    }

    if (this.props.instances.size >= this.props.maxNumberOfSections)
    {
      return false;
    }

    let instance = this.props.instances.get(this.props.instances.size);
    
    return instance === undefined || (this.props.isEmpty !== undefined && !this.props.isEmpty(instance));
  }
  
  public onFieldChange(instanceId: number, event: IFieldEvent) {
    if (this.props.onFieldChange !== undefined) {
      this.props.onFieldChange({
        instanceId: instanceId,
        ...event
      });
    }
  }

  public render() {
    let instancedSections = [];

    if (this.props.instances.size === 0)
    {
      instancedSections.push(this.props.noSectionText);
    }
    else {
      instancedSections = this.getComponents();
    }

    let addInstanceDisabled = !this.addInstanceAvailable();

    return <React.Fragment>
      <Section name={this.props.label} onAdd={this.props.onAddInstance} addDisabled={addInstanceDisabled}>
        {instancedSections}
      </Section>
    </React.Fragment>;
  }
}

